import { User } from '@lib/@m7/oauth2-client';
import { User as IUser } from '@types';

import { ActorModel } from './ActorModel';
import { fillObjectProps } from '@/mixins';

const LOC_STORAGE_KEY = 'user';

export class UserModel extends User implements IUser {
    [key: string]: any;
    actor: ActorModel = null;
    terms_agreed: string = null;
    impersonatedBy: UserModel = null;

    constructor(data: IUser) {
        super({ ...data });

        fillObjectProps(this, data, {
            onFill: (key, value) => {
                switch (key) {
                    case 'actor':
                        this[key] = value ? new ActorModel(value) : null;
                        return true;
                    case 'impersonatedBy':
                        this[key] = value ? new UserModel(value) : null;
                        return true;
                }
            },
        });
    }

    getActor(): ActorModel {
        return this.actor;
    }

    hasAgreedTerms(): boolean {
        return !!this.terms_agreed;
    }

    isImpersonated(): boolean {
        return !!this.impersonatedBy?.id ?? false;
    }

    static getFromLocalStorage(key: string = null): UserModel {
        let data = window.localStorage.getItem(key || LOC_STORAGE_KEY);
        if (!data || data === 'undefined') return null;
        return new this(JSON.parse(data));
    }

    saveToLocalStorage(key: string = null): UserModel {
        window.localStorage.setItem(key || LOC_STORAGE_KEY, JSON.stringify(this));
        return this;
    }
}
